import React, {Component} from 'react';
import PropTypes from 'prop-types';

import template from './FilterItemsHeader.rt';

export default class FilterItemsHeader extends Component {
  constructor(props) {
    super(props);
  }

  setSearchTerm = term => {
    this.props.setFilterItemSearchText(term)
  }

  render() {
    return template.apply(this);
  }
}

FilterItemsHeader.propTypes = {
  getFilterGroupItems: PropTypes.func.isRequired
};

